import { render, staticRenderFns } from "./TaskActiveDialog.vue?vue&type=template&id=3ccfb94c&"
import script from "./TaskActiveDialog.vue?vue&type=script&lang=js&"
export * from "./TaskActiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports